import DOMPurify from "dompurify";

export default function RichText({ html, className = "" }) {
  const clean = DOMPurify.sanitize(html || "", {
    ALLOWED_TAGS: ["p", "br", "span", "div", "h1", "h2", "h3", "h4", "h5", "h6", "strong", "b",
      "em", "i", "u", "s", "ul", "ol", "li", "a", "blockquote", "hr"],
    ALLOWED_ATTR: ["href", "title", "target", "rel", "style"],
  });
  return <div className={`prose-hr ${className}`} dangerouslySetInnerHTML={{ __html: clean }} />;
}
